import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function SpendSmartPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🤑"
      heading={t('pages.onboarding.spendSmart.heading')}
      text={t('pages.onboarding.spendSmart.text')}
      onSubmit={handleSubmit}
    />
  )
}
